import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output, Renderer2,
  ViewChild
} from '@angular/core';
import {InBaseFrwComponent} from '../inBaseFrwComponent';

@Component({
  selector: 'cmp-aside-template',
  template: `<input  #inputElement type="checkbox" role="button"/>
<span (click)="inputElement.click()">

  <ng-content></ng-content>
</span>
<div class="aside-bg"></div>
<div class="aside flex-column">
  <div class="aside-header clearfix p-3 aside-title ">
    <h6 class="mb-0 float-left" *ngIf="title">{{title}}</h6>
    <button (click)="inputElement.click()" class="btn rounded-circle text-danger btn-light float-right" >X</button>
  </div>
  <div class="aside-body p-3" *ngIf="templateBody">
    <ng-container *ngTemplateOutlet="templateBody"></ng-container>
  </div>
  <div class="aside-footer p-3 clearfix" *ngIf="templateFooter">
    <ng-container *ngTemplateOutlet="templateFooter"></ng-container>
  </div>
</div>
`,
  styles: [`input[type=checkbox]{display:none}input:checked~.aside-bg{right:0;background-color:rgba(0,0,0,.6);transition:right .1s}input:checked~.aside{right:0;transition:right .5s}.aside-bg{position:fixed;top:55px;width:100%;right:-10000px;height:100%;background-color:rgba(0,0,0,.6);z-index:1205;transition:right .3s}.aside{position:fixed;top:55px;right:-520px;width:500px;height:100%;background-color:#fff;z-index:1210;border-left:1px solid #ccc;overflow:auto;transition:right .5s}:host(.aside-footer){height:80px;width:500px;background-color:#f8f9fa;border-top:1px solid #dee2e6}:host{display:block}:host(.aside-body){position:relative;height:calc(100% - 158px);overflow:auto}::ng-deep .media .avatar-media{width:40px;height:40px;text-align:center;padding-top:8px;background-color:#2d6daa;color:#fff}::ng-deep .media .avatar-name{margin-top:10px}::ng-deep .icon-list{width:30px;height:30px;text-align:center}::ng-deep .nav .nav-item .nav-link.active{border-bottom:2px solid #2d6daa}`]
})
export class AsideTemplateComponent extends InBaseFrwComponent implements AfterViewInit {

  @Input() asideTemplate;
  @Input() templateBody;
  @Input() templateFooter;
  @Input() title;
  @Output() isAsideOpen = new EventEmitter();
  @Output() outletEmit = new EventEmitter();
  @ViewChild('inputElement') inputElement;

  constructor(private renderer: Renderer2) {
    super();
  }

  ngAfterViewInit() {
    this.renderer.listen(this.inputElement.nativeElement, 'click', () => {
      this.isAsideOpen.emit(this.inputElement.nativeElement.checked);
    });
    this.outletEmit.emit(this.inputElement.nativeElement);
  }
}
